import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HandleHttpError } from './error.handler';
import { PreRegistrationModel } from '../models/pre-registration.model';
import { SharedService } from './shared.service';

@Injectable()
export class DataService {

    baseURL: string;

    constructor(private http: HttpClient, private sharedService: SharedService) {
        this.baseURL = this.sharedService.getBaseURL();
    }


    registerUser(registrationModel: PreRegistrationModel): Observable<any> {
        return this.http.post(`${this.baseURL}/api/registrations/register-user`, registrationModel)
                    .pipe(catchError(err => HandleHttpError(err)));
    }



    ValidateStudentParentsInfo(studentGivenName: string,
                        studentFamilyName: string,
                        studentDateOfBirth: string,
                        studentCountryCode: string,
                        fatherGivenName?: string,
                        fatherFamilyName?: string,
                        motherGivenName?: string,
                        motherFamilyName?: string,
                        ): Observable<any> {

        const body = {
            'GivenName': studentGivenName,
            'FamilyName': studentFamilyName,
            'DateOfBirth': studentDateOfBirth,
            'CountryCode': studentCountryCode,
            'FatherGivenName': fatherGivenName,
            'FatherFamilyName': fatherFamilyName,
            'MotherGivenName': motherGivenName,
            'MotherFamilyName': motherFamilyName
        };

        return this.http.post(`${this.baseURL}/applications`, body)
                        .pipe(
                            catchError(err => HandleHttpError(err))
                        );


    }

}
